export const WEB_URL = "https://prajavarta.com/Admin/api_v1.php";
export const ADS_URL = "https://prajavarta.com/Admanager/ser.php"

export const NEWS = `${WEB_URL}/news`;
export const SALT = "699";
export const PACKAGE_NAME = "com.prajavarta"
export const SIGN_KEY = "3df6d220fa247a377807a130090b831d";


